export default `
query categories{ 
    categories {
        id
        title
    }
  }
`;
